import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push as pushAction } from 'connected-react-router';

import { createBlacklist as createBlacklistAction } from '../../../actions/BlacklistActions';

import { BlacklistForm } from '../../../components';

class BlacklistAddPage extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        organizationId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    errorMessage: PropTypes.string,
    push: PropTypes.func.isRequired,
    createBlacklist: PropTypes.func.isRequired,
  };

  static defaultProps = {
    errorMessage: null,
  };

  render() {
    const {
      match: {
        params: { organizationId },
      },
      errorMessage,
      createBlacklist,
      push,
    } = this.props;

    return (
      <div className="row" id="user-add">
        <div className="col-12">
          <div className="row page-titles">
            <div className="col-12">
              <h3 className="text-themecolor">Create Blacklist</h3>
            </div>
          </div>

          <div className="card">
            <div className="card-block">
              <BlacklistForm
                organizationId={organizationId}
                errorMessage={errorMessage}
                isNew={true}
                onSubmit={values =>
                  createBlacklist(organizationId, values).then(() =>
                    push(`/organizations/${organizationId}/blacklists`)
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ blacklists: { errorMessage } }) => ({ errorMessage }),
  { createBlacklist: createBlacklistAction, push: pushAction }
)(BlacklistAddPage);
